// What to do with a 401 that is a genuine authentication failure.
export const UNAUTHORIZED = {
  REPORT: 'report',
  RETRY: 'retry',
  REFRESH: 'refresh',
};

/**
 * @description Decide how to answer a 401.
 *
 * - REPORT: this request has already been through a refresh and come back 401
 *   again. Parking it a second time would refresh, retry and 401 in a loop.
 * - RETRY: it was sent with a token that has since been replaced, so it is a
 *   round trip cheaper to send it again with the current one than to refresh.
 *   A missing current token means the session really ended, which is not this.
 * - REFRESH: an ordinary expired token.
 *
 * Lives apart from `./axios` for the same reason `./tokenRefresh` does —
 * importing that module registers the interceptors and pulls in the store and
 * router, and `responseErrorHandler` returns early under NODE_ENV=test
 * (isTestMode), which leaves every one of these branches unreachable from a
 * unit test. Pure, with no dependencies at all.
 * @param isRetry whether the request carries isRetriedAfterRefresh
 * @param usedToken the bearer value the request was sent with
 * @param currentToken the token in the store now
 * @returns {string} one of UNAUTHORIZED
 */
export const decideUnauthorized = ({ isRetry, usedToken, currentToken }) => {
  if (isRetry) {
    return UNAUTHORIZED.REPORT;
  }

  if (usedToken && currentToken && usedToken !== currentToken) {
    return UNAUTHORIZED.RETRY;
  }

  return UNAUTHORIZED.REFRESH;
};
